module.exports = __webpack_public_path__ + "static/img/アセット 14@2x.53a6af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/meal_entry/アセット 14@2x.png
// module id = Xbda
// module chunks = 1